module.exports = __webpack_public_path__ + "static/media/mealtrist-featured-meal.c982346e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mealtrist-featured-meal.jpg
// module id = 71
// module chunks = 0